// extracted by mini-css-extract-plugin
export default {"linkToUpButton":"_1WrFevZl0MRj5oOpat7Ld3","advButtonText":"uRAKo8Ro_lNhJV4LX3V70"};